import { render, staticRenderFns } from "./app-role.vue?vue&type=template&id=537cfd42&scoped=true&"
import script from "./js/app-role.js?vue&type=script&lang=js&"
export * from "./js/app-role.js?vue&type=script&lang=js&"
import style0 from "./app-role.vue?vue&type=style&index=0&id=537cfd42&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "537cfd42",
  null
  
)

export default component.exports